import { DESC } from 'framework/list';
import type { CollectionViewParamsConfig } from 'framework/ViewTypes';
import { type FilterState } from 'framework/ViewTypes/components';
import { FilterCondition } from 'framework/types';
import { useCollectionPager } from 'framework/ViewTypes/hooks';
import { VENDOR_PROFILE_STATUSES, VENDOR_WORKING_STATUSES } from '../constants';
import type { VendorDto } from '../types';
import useVendorService from '../useVendorService';

const VIEW_PARAMS_CONFIG: CollectionViewParamsConfig<FilterState> = {
  defaultSortBy: 'createdAt',
  defaultSortOrder: DESC,
  cache: true,
  filterRules: {
    owner: { condition: FilterCondition.EQ },
    profileStatus: { condition: FilterCondition.IN, values: Object.values(VENDOR_PROFILE_STATUSES) },
    workingStatus: { condition: FilterCondition.IN, values: Object.values(VENDOR_WORKING_STATUSES) },
    isCompliant: { condition: FilterCondition.EQ, values: ['YES', 'NO'] },
  },
  sortableColumns: ['createdAt'],
};

const useVendorsCollection = () => {
  const { searchVendors } = useVendorService();

  return useCollectionPager<VendorDto, FilterState>({
    pageSize: 30,
    viewParamsConfig: VIEW_PARAMS_CONFIG,
    fetchPage: ({ pageNumber, pageSize, filters, searchValue, sort, signal }) =>
      searchVendors({ pageNumber, pageSize, filter: filters, searchValue, sort }, { signal }),
  });
};

export default useVendorsCollection;
